export enum Options { 
    yes=1,
    No=2,
    }